import { render, staticRenderFns } from "./message.vue?vue&type=template&id=a5c8fa5e&scoped=true"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"
import style0 from "./message.vue?vue&type=style&index=0&id=a5c8fa5e&prod&scoped=true&lang=scss"
import style1 from "./message.vue?vue&type=style&index=1&id=a5c8fa5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c8fa5e",
  null
  
)

export default component.exports